export default "__VITE_ASSET__CckbTy9C__"